import React from 'react';
import Divider from '@mui/material/Divider';

import { styled } from '@mui/material/styles';
import WidgetCard from 'components/Widget/WidgetCard';
import { NestedMenuOptionT } from 'ui/NestedMenu/NestedMenu';

type Props = {
    editMode: boolean;
    canEdit: boolean;
    menuItems: NestedMenuOptionT[];
};

const StySeparator = styled(Divider, {
    name: 'StySeparator',
})(({ theme }) => ({
    height: '5px',
    margin: 'auto',
    width: '100%',
    backgroundColor: theme.palette.primary.main,
}));

export default function SeparatorWidget({
    editMode,
    menuItems,
    canEdit,
}: Props): React.ReactElement {
    return (
        <WidgetCard
            transparent
            editMode={editMode}
            menuItems={menuItems}
            canEdit={canEdit}
            data-testid="divider-widget"
        >
            <StySeparator />
        </WidgetCard>
    );
}
